import { takeLatest, call, put, all } from 'redux-saga/effects';

/* reducer, selector, action */
import {
	fetchAdvanceSearchFiltersSuccess,
	fetchAdvanceSearchFiltersFailure,
	fetchAdvanceSearchSuccess,
	fetchAdvanceSearchFailure,
	fetchNavAdvanceSearchSuccess,
	fetchNavAdvanceSearchFailure,
	updateDefaultQueriesAdvanceSearch
} from '../_actions/advance-search.actions';

import { advanceSearchConstants } from '../_constants/advance-search.constants';

import {
	fetchAdvanceSearchFilters,
	fetchNavForAdvanceSearch
} from '../_services/advance-search.services';
import { fetchFundSearch } from '../_services/information.services';

// Worker
export function* fetchAdvanceSearchFiltersAsync() {
	try {
		const result = yield call(fetchAdvanceSearchFilters);
		yield put(updateDefaultQueriesAdvanceSearch(result.data));
		yield put(fetchAdvanceSearchFiltersSuccess(result.data));
	} catch (error) {
		yield put(fetchAdvanceSearchFiltersFailure(error));
	}
}

export function* fetchAdvanceSearchAsync({ payload }) {
	try {
		const result = yield call(fetchFundSearch, payload);
		yield put(fetchAdvanceSearchSuccess(result.data));
	} catch (error) {
		yield put(fetchAdvanceSearchFailure(error));
	}
}

export function* fetchNavAdvanceSearchAsync({ payload }) {
	try {
		const result = yield call(fetchNavForAdvanceSearch, payload);
		yield put(fetchNavAdvanceSearchSuccess(result.data));
	} catch (error) {
		yield put(fetchNavAdvanceSearchFailure(error));
	}
}

// Watcher
export function* fetchAdvanceSearchFiltersToSaga() {
	yield takeLatest(advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_START, fetchAdvanceSearchFiltersAsync);
}

export function* fetchAdvanceSearchToSaga() {
	yield takeLatest(advanceSearchConstants.FETCH_ADVANCE_SEARCH_START, fetchAdvanceSearchAsync);
}

export function* fetchNavAdvanceSearchToSaga() {
	yield takeLatest(advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_START, fetchNavAdvanceSearchAsync);
}

// Call Root-Saga
export function* advanceSearchSagas() {
	yield all([
		call(fetchAdvanceSearchFiltersToSaga), 
		call(fetchAdvanceSearchToSaga), 
		call(fetchNavAdvanceSearchToSaga)
	]);
}
